import { motion } from "framer-motion";

const skillGroups = [
  {
    category: "Cloud & Infrastructure",
    icon: "☁️",
    skills: [
      { name: "AWS (EC2, S3, RDS, IAM, VPC, Cognito)", level: 90 },
      { name: "VPS Management", level: 85 },
      { name: "Terraform", level: 80 },
    ],
  },
  {
    category: "DevOps & CI/CD",
    icon: "🔄",
    skills: [
      { name: "GitHub Actions", level: 92 },
      { name: "Jenkins", level: 85 },
      { name: "CI/CD Pipelines", level: 90 },
      { name: "Docker & Docker Compose", level: 90 },
      { name: "Kubernetes (K8s / EKS)", level: 85 },
    ],
  },
  {
    category: "Frontend",
    icon: "🎨",
    skills: [
      { name: "Angular (18 / 19)", level: 88 },
      { name: "Next.js", level: 82 },
      { name: "TypeScript / JavaScript", level: 88 },
      { name: "HTML / CSS / TailwindCSS", level: 90 },
      { name: "Ionic", level: 75 },
    ],
  },
  {
    category: "Backend & Database",
    icon: "⚙️",
    skills: [
      { name: "Node.js", level: 80 },
      { name: "Python", level: 75 },
      { name: "Supabase", level: 82 },
      { name: "Firebase", level: 78 },
      { name: "PostgreSQL / MySQL (RDS)", level: 80 },
    ],
  },
  {
    category: "Networking & Security",
    icon: "🔐",
    skills: [
      { name: "NGINX Reverse Proxy", level: 88 },
      { name: "SSL / HTTPS Certificates", level: 90 },
      { name: "DNS & Domain Management", level: 88 },
      { name: "VPS Security Hardening", level: 85 },
    ],
  },
  {
    category: "Tools & Monitoring",
    icon: "📊",
    skills: [
      { name: "Git & GitHub", level: 92 },
      { name: "Postman / API Testing", level: 88 },
      { name: "Linux Administration", level: 90 },
      { name: "Server Monitoring & Logs", level: 85 },
      { name: "WebRTC / Socket.io", level: 78 },
    ],
  },
];

export default function Skills() {
  return (
    <section id="skills" className="py-16 md:py-24 px-4 sm:px-6 bg-[#0d1526]/50">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <p className="text-sky-400 font-semibold uppercase tracking-widest text-sm mb-2">What I Work With</p>
          <h2 className="text-4xl md:text-5xl font-black text-white">Skills & Tools</h2>
          <div className="w-16 h-1 bg-sky-500 mx-auto mt-4 rounded-full" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {skillGroups.map((group, gi) => (
            <motion.div
              key={group.category}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: gi * 0.1 }}
              className="bg-[#0a0f1e] border border-sky-500/15 rounded-2xl p-6 card-hover"
            >
              <div className="flex items-center gap-3 mb-5">
                <span className="text-2xl">{group.icon}</span>
                <h3 className="text-white font-bold text-sm">{group.category}</h3>
              </div>
              <div className="space-y-4">
                {group.skills.map((skill, si) => (
                  <div key={skill.name}>
                    <div className="flex justify-between mb-1">
                      <span className="text-slate-300 text-xs">{skill.name}</span>
                      <span className="text-sky-400 text-xs font-bold">{skill.level}%</span>
                    </div>
                    <div className="w-full bg-slate-800 rounded-full h-1.5">
                      <motion.div
                        initial={{ width: 0 }}
                        whileInView={{ width: `${skill.level}%` }}
                        viewport={{ once: true }}
                        transition={{ duration: 1, delay: gi * 0.1 + si * 0.08 }}
                        className="h-1.5 rounded-full bg-gradient-to-r from-sky-500 to-blue-400"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
